import type {
  ClientEntitlement,
  EntitlementGateDescriptor,
  EntitlementGateResult,
  EntitlementFeatureAction,
  EntitlementFeatureGroup,
  EntitlementFeatureResource,
} from '@/types/entitlement';

function getPermissionValue(
  permissions: ClientEntitlement['plan_permission'],
  resource: EntitlementFeatureResource,
  action: EntitlementFeatureAction,
  permissionGroup?: EntitlementFeatureGroup
): boolean | undefined {
  const resourcePermission = permissions?.[resource];

  if (permissionGroup) {
    if (action === 'create' || action === 'update' || action === 'view' || action === 'delete') {
      return resourcePermission?.[permissionGroup]?.[action];
    }

    return undefined;
  }

  return resourcePermission?.[action];
}

function isAdminOnlyResource(resource: EntitlementFeatureResource): boolean {
  return (
    resource === 'billing_info' ||
    resource === 'client' ||
    resource === 'integration' ||
    resource === 'subscription_plan' ||
    resource === 'user'
  );
}

export function checkEntitlementGate(
  entitlement: ClientEntitlement | null | undefined,
  descriptor: EntitlementGateDescriptor
): EntitlementGateResult {
  if (!entitlement) {
    return {
      allowed: true,
      variant: null,
    };
  }

  const userFeatureAllowed = getPermissionValue(
    entitlement.user_permission,
    descriptor.resource,
    descriptor.action,
    descriptor.permissionGroup
  );

  if (userFeatureAllowed === false) {
    return {
      allowed: false,
      variant: 'access_restricted',
      reason: 'user_permission_denied',
      resource: descriptor.resource,
      action: descriptor.action,
      permissionGroup: descriptor.permissionGroup,
      limitResource: descriptor.limitResource,
      limitKey: descriptor.limitKey,
      accessRestriction: isAdminOnlyResource(descriptor.resource) ? 'admin_required' : 'view_only',
    };
  }

  return {
    allowed: true,
    variant: null,
  };
}
